<template>
  <div v-show='cpntMostrar' class="rf-input-group" :class='cpntClassDivField'>
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='status !== ""'>
      <RF-Status :cpntStatus='status' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <the-mask v-if="cpntMask === 'telefone'" 
        :mask="[ '(##)####-####', '(##)#####-####' ]" 
        :masked='true' 

        :id='cpntId' 
        :tabIndex='cpntTabIndex'
        :class='classCampo'
        :autocomplete='cpntAutoComplete'
        :autofocus='cpntAutoFocus'
        :disabled='cpntDisabled'
        :placeholder="cpntPlaceholder"
        :maxlength="maxLength"

        v-model='value'

        @keyup='onKeyUp'
        @keyup.enter='onKeyPressEnter'
        @blur='onBlur'
        @focus='onFocus'
      ></the-mask>

      <the-mask v-else-if="cpntMask === 'cnpj_cpf'" 
        :mask="[ '###.###.###-##', '##.###.###/####-##' ]" 
        :masked='true' 

        :id='cpntId' 
        :tabIndex='cpntTabIndex'
        :class='classCampo'
        :autocomplete='cpntAutoComplete'
        :autofocus='cpntAutoFocus'
        :disabled='cpntDisabled'
        :placeholder="cpntPlaceholder"
        :maxlength="maxLength"

        v-model='value'

        @keyup='onKeyUp'
        @keyup.enter='onKeyPressEnter'
        @blur='onBlur'
        @focus='onFocus'
      ></the-mask>

      <template v-else-if="mascara !== '' && mascara !== null && mascara.length >= 1">
        <the-mask
          :mask="mascara" 
          :masked='true' 

          :id='cpntId' 
          :tabIndex='cpntTabIndex'
          :class='classCampo'
          :autocomplete='cpntAutoComplete'
          :autofocus='cpntAutoFocus'
          :disabled='cpntDisabled'
          :placeholder="cpntPlaceholder"
          :maxlength="maxLength"

          v-model='value'

          @keyup='onKeyUp'
          @keyup.enter='onKeyPressEnter'
          @blur='onBlur'
          @focus='onFocus'
        ></the-mask>
      </template>

      <input :ref='cpntId' v-else-if='[ "text", "number", "password" ].indexOf(type) !== -1'
        :style="cpntMask === 'placa' ? 'text-transform: uppercase;' : ''"

        :id='cpntId' 
        :name='cpntId' 
        :type="type" 
        :tabIndex='cpntTabIndex'
        :class='classCampo'
        :autocomplete='cpntAutoComplete'
        :autofocus='cpntAutoFocus'
        :disabled='cpntDisabled'
        :placeholder="cpntPlaceholder"
        :maxlength="maxLength"

        v-model='value'

        @keyup='onKeyUp'
        @keyup.enter='onKeyPressEnter'
        @blur='onBlur'
        @focus='onFocus'
      >

      <span class="rf-barra"></span>
      <label :for='cpntId' :class='"has-" + cpntMensagemTipo'>
        <span v-html='cpntNome'></span>

        <RF-Explica v-if='[ "", null, undefined ].indexOf(cpntExplica) === -1 && Object.keys(cpntExplica).length >= 1'
          :cpntId='cpntId + "-explica"' 
          :cpntTitle='cpntExplica.mensagem'
          :cpntPositionMy='cpntExplica.posicaoMy'
          :cpntPositionAt='cpntExplica.posicaoAt'
          :cpntClasses='cpntExplica.class'

          style='vertical-align: 0px;'
        ></RF-Explica>
      </label>
      <span v-if='cpntMensagem !== "" && cpntMensagem !== null' v-html='cpntMensagem' :class='"has-" + cpntMensagemTipo'></span>
    </template>
  </div>
</template>

<style scoped>
input[type=number]::-webkit-inner-spin-button { 
  -webkit-appearance: none;
  -moz-appearance: textfield;
  appearance: textfield;
}

/* -=-=-=-=-=-= ESTILO INICIAL =-=-=-=-=-=- */
.rf-input-group {
  position: relative;
  margin-bottom: 30px;
}

/* ------------------ CONFIGURA O INPUT ------------------ */
.rf-input-group > input {
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #CCC;
  padding: 5px 5px 5px 5px;
  color: #292b2c;
 }
  /* ------------------ REMOVE BORDAS INPUT QUANDO DA FOCUS ------------------ */
  .rf-input-group > input:focus { 
    outline: none; 
  }

/* ------------------ MODO DE ABERTURA DA ANIMAÇÃO ------------------ */
.rf-barra:before { 
  left: 50%;
  height: 0px;
}
.rf-barra:after {
  right: 50%;
  height: 0px;
}
.rf-input-group > input:focus ~ .rf-barra:before, .rf-input-group > input:focus ~ .rf-barra:after {
  width: 50%;
  height: 2px;
}
/* ------------------ APRESENTA A BARRA ABAIXO DO INPUT QUANDO SELECIONADO ------------------ */
.rf-barra {
  position: relative;
  display: block;
  width: 100%;
 }
.rf-barra:before, .rf-barra:after {
  position: absolute;
  bottom: 1px;
  content: '';
  width: 0px;
  /* height: 2px; */
  background: #4285f4;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
 }
/* ------------------ TITULO DO CAMPO ------------------ */
.rf-input-group > label {
  position: absolute;
  left: 0px;
  top: -20px;
  color: var(--color-base-02);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;

  margin: 0px;
  white-space: nowrap;
 }   
  /* ------------------ LOCAL E COR QUE FICA O TITULO DO CAMPO APÓS PREENCHIDO ------------------ */
  .rf-input-group > input:focus ~ label, .rf-input-group > input.rf-input-focus-true ~ label {
    top: -20px;
  }
  .rf-input-group > input:focus ~ label {
    color: #4285f4;
  }
  /* ------------------ ALTERA A COR CASO NÃO SEJA VALIDADO ------------------ */
    .rf-input-group > input.has-error ~ label {
      top: -20px;
      color: #a94442;
    }
    .rf-input-group > input.has-error ~ .rf-barra:before, .rf-input-group > input.has-error ~ .rf-barra:after {
      position: absolute;
      bottom: 1px;
      content: '';
      width: 0px;
      height: 2px;
      background: #a94442;
      transition: 0.2s ease all;
      -moz-transition: 0.2s ease all;
      -webkit-transition: 0.2s ease all;
      width: 50%;
    }

    .rf-input-group > input:disabled {
      background: #fff;
      color: rgba(0, 0, 0, 0.65);
      cursor: not-allowed;
    }

.rf-input-group > input {
  padding: 4px 5px 4px 5px;
  border-radius: 5px;
  border: 1px solid #e9e9e9;
  border-bottom: 1px solid #d0d0d0;
  height: 30px;
}
</style>

<script>
  import { TheMask } from 'vue-the-mask'

  export default {
    name: 'RF-Input',
    components: {
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      TheMask
    },
    props: {
      cpntStatus: {
        required: true
      },
      cpntId: {
        required: true,
        type: String
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntType: {
        required: false,
        type: String,
        validator: function (val) {
          return ([ 'text', 'password', 'number' ].indexOf(val) !== -1)
        },
        default: function () {
          return 'text'
        }
      },
      cpntValue: {
        required: true,
        type: [ String, Number ]
      },
      cpntMask: {
        required: false,
        type: String,
        validator: function (val) {
          return ([ null, 'cnpj_cpf', 'valor', 'valorDecimal', 'valorDecimal2', 'cnpj', 'cpf', 'placa', 'data', 'telefone', 'cep' ].indexOf(val) !== -1)
        },
        default: function () {
          return null
        }
      },
      cpntAutoComplete: {
        type: String,
        required: false,
        default: 'off'
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntAutoFocus: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntPlaceholder: {
        type: String,
        required: false,
        default: ''
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntClassDivField: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return []
        }
      },
      cpntMaxLength: {
        type: Number,
        required: false,
        default: function () {
          return 99999999
        }
      },

      // FUNÇOES DO COMPONENT
      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnKeyUp: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnKeyPressEnter: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnBlur: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnFocus: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        status: '',
        value: this.cpntValue,
        classCampo: [],
        bloqueado: false,
        maxLength: 99999999,
        mascara: [],
        type: this.cpntType
      }
    },
    mounted: function () {
      this.iniciarCampo()
    },
    methods: {
      iniciarCampo: function () {
        // SETA O STATUS
        this.status = 'carregando'

        // RESETA AS CLASSES DO INPUT
        this.classCampo = []

        // CHAMA FUNÇÃO PARA VERIFICAR SE O CAMPO TEM VALOR
        this.checarClassCampo()

        // ALTERA O STATUS
        this.status = ''

        // INICIA A MONTAGEM DA MASCARA NO INPUT
        this.montarMascara()
      },
      montarMascara: function () {
        if (this.cpntMask !== null) {
          var self = this

          switch (self.cpntMask) {
            case 'valor':
              // SETA A QUANTIDADE DE CARACTERES NO CAMPO
              self.maxLength = 13

              // CHAMA A FUNÇÃO PARA MONTAR A MASCARA DE VALOR
              self.onMaskValor(self.cpntValue)
              break

            case 'valorDecimal':
              // SETA A QUANTIDADE DE CARACTERES NO CAMPO
              self.maxLength = 10

              // CHAMA A FUNÇÃO PARA MONTAR A MASCARA DE VALOR
              self.onMaskValorDecimal(self.cpntValue)
              break

            case 'valorDecimal2':
              // SETA A QUANTIDADE DE CARACTERES NO CAMPO
              self.maxLength = 9

              // // CHAMA A FUNÇÃO PARA MONTAR A MASCARA DE VALOR
              // if ([ '0,00', '' ].indexOf(self.cpntValue) === -1) {
              //   self.onMaskValorDecimal2(self.cpntValue, true)
              // }
              break

            case 'cpf':
              // SETA A QUANTIDADE DE CARACTERES NO CAMPO
              self.maxLength = 14

              // SETA A MARCARA QUE DEVE SER UTILIZADA
              self.mascara = '###.###.###-##'
              break

            case 'cnpj':
              // SETA A QUANTIDADE DE CARACTERES NO CAMPO
              self.maxLength = 18

              // SETA A MASCARA UTILIZADA NO PLUGIN
              self.mascara = '##.###.###/####-##'
              break

            case 'data':
              // SETA A QUANTIDADE DE CARACTERES NO CAMPO
              self.maxLength = 10

              // SETA A MASCARA UTILIZADA NO PLUGIN
              self.mascara = '##/##/####'
              break

            case 'placa':
              // SETA A QUANTIDADE DE CARACTERES NO CAMPO
              self.maxLength = 7

              // SETA A MASCARA UTILIZADA NO PLUGIN
              self.mascara = 'AAA#X##'
              break

            case 'telefone':
              // SETA A QUANTIDADE DE CARACTERES NO CAMPO
              self.maxLength = 15

              // SETA A MASCARA UTILIZADA NO PLUGIN
              self.mascara = '(##) ####-####' // [ '(##) ####-####', '(##) #####-####' ]
              break

            case 'cnpj_cpf':
              // SETA A QUANTIDADE DE CARACTERES NO CAMPO
              self.maxLength = 18

              // SETA A MASCARA UTILIZADA NO PLUGIN
              self.mascara = [ '###.###.###-##', '##.###.###/####-##' ]
              break

            case 'cep':
              // SETA A QUANTIDADE DE CARACTERES NO CAMPO
              self.maxLength = 8

              // SETA A MASCARA UTILIZADA NO PLUGIN
              self.mascara = '########'
              break
          }
        } else {
          // SETA O TAMANHO MAXIMO INICIAL
          this.maxLength = this.cpntMaxLength

          // LIMPA A MASCARA EXISTENTE
          this.mascara = []
        }
      },
      checarClassCampo: function () {
        // REMOVE AS CLASSES DE FOCUS
        this.classCampo = this.classCampo.filter(item => (item !== 'rf-input-focus-true' && item !== 'rf-input-focus-false'))

        // VERIFICA SE O VALOR FOI PREENCHIDO
        if (this.value !== '') {
          this.classCampo.push('rf-input-focus-true')
        } else {
          this.classCampo.push('rf-input-focus-false')
        }
      },
      onFocusField: function (scroll) {
        this.$store.state.ON_FOCUS_CAMPO('RF-Input', this.cpntId, scroll) // CHAMA FUNÇÃO PARA DAR FOCUS E DAR SCROOL NA TELA
      },
      onKeyPressEnter: function () {
        if (this.cpntOnKeyPressEnter !== null) {
          this.cpntOnKeyPressEnter(this.cpntId)
        }
      },
      onKeyUp: function (event) {
        switch (event.key) {
          case 'Enter':
            break

          default:
            if (this.cpntOnKeyUp !== null) {
              this.cpntOnKeyUp(event, this.cpntId)
            }
            break
        }
      },
      onFieldBlur: function () {
        if (this.cpntOnFieldBlur !== null) {
          this.cpntOnFieldBlur(this.cpntId)
        }
      },
      onFieldFocus: function () {
        if (this.cpntOnFieldFocus !== null) {
          this.cpntOnFieldFocus(this.cpntId)
        }
      },
      onMaskValorDecimal2: function (valor, removeZero = false) {
        // FORMATA O VALOR RECEBIDO
        valor = this.$store.state.FUN_MASK_VALOR('valorDecimal2', valor, removeZero)

        // SETA O VALOR ATUALIZADO NO CAMPO
        this.value = valor

        // VERIFICA SE TEM QUE ATUALIZAR O COMPONENT PAI
        if (this.cpntValue !== this.value) {
          this.onChange(valor, false)
        }
      },
      onMaskValorDecimal: function (valorRecebido) {
        var negativo = valorRecebido.toString().substring(0, 1) === '-'
        if (negativo === true) {
          valorRecebido = valorRecebido.substring(1, valorRecebido.length)
        }

        var valorOriginal = valorRecebido
        var tamanho = valorOriginal.length

        // eliminando que o usuario digite qualquer letra do alfabeto ou caracteres estranhos
        var digits = '0123456789,'

        for (var v = 0; v < tamanho; v++) {
          if (digits.indexOf(valorOriginal.charAt(v)) === -1) {
            valorOriginal = valorOriginal.substring(0, v)
            break
          }
        }

        valorRecebido = valorOriginal

        if (negativo === true) {
          valorRecebido = '-' + valorRecebido
        }

        if (this.cpntValue !== valorRecebido) {
          this.onChange(valorRecebido, false)
        }
      },
      onMaskValor: function (valor) {
        if (valor === null) {
          valor = ''
        }

        // VERIFICA SE O NUMERO TEM SINAL NEGATIVO
        var negativo = valor.toString().substring(0, 1) === '-'

        // DEIXA APENAS NUMEROS
        valor = valor.toString().match(/[0-9]+/g)

        if (valor === null) {
          valor = ''
        } else {
          valor = valor.join('')
        }

        var cont = 0
        // REMOVE OS ZEROS A ESQUERDA
        for (var k = 0; k < valor.length; k++) {
          if (valor[k] === '0') {
            cont++
          } else {
            break
          }
        }
        valor = valor.substring(cont, valor.length)

        switch (valor.length) {
          case 0:
            valor = '0,00'
            break

          case 1:
            valor = '0,0' + valor
            break

          case 2:
            valor = '0,' + valor
            break

          case 3:
            valor = valor.substr(0, 1) + ',' + valor.substr(1, 2)
            break

          case 4:
            valor = valor.substr(0, 2) + ',' + valor.substr(2, 2)
            break

          case 5:
            valor = valor.substr(0, 3) + ',' + valor.substr(3, 2)
            break

          case 6:
            valor = valor.substr(0, 1) + '.' + valor.substr(1, 3) + ',' + valor.substr(4, 2)
            break

          case 7:
            valor = valor.substr(0, 2) + '.' + valor.substr(2, 3) + ',' + valor.substr(5, 2)
            break

          case 8:
            valor = valor.substr(0, 3) + '.' + valor.substr(3, 3) + ',' + valor.substr(6, 2)
            break

          case 9:
            valor = valor.substr(0, 1) + '.' + valor.substr(1, 3) + '.' + valor.substr(4, 3) + ',' + valor.substr(7, 2)
            break

          case 10:
            valor = valor.substr(0, 2) + '.' + valor.substr(2, 3) + '.' + valor.substr(5, 3) + ',' + valor.substr(8, 2)
            break

          case 11:
            valor = valor.substr(0, 3) + '.' + valor.substr(2, 3) + '.' + valor.substr(5, 3) + ',' + valor.substr(8, 2)
            break
        }

        if (negativo === true) {
          valor = '-' + valor
        }

        if (this.cpntValue !== valor) {
          this.onChange(valor)
        }
      },
      onChange: function (valor, fazerMascara = true) {
        if (this.cpntMask === 'valorDecimal' && fazerMascara === true) {
          this.onMaskValorDecimal(valor)
        } else if (this.cpntOnChange !== null) {
          this.cpntOnChange(valor, this.cpntId)
        }
      },
      onBlur: function () {
        if (this.cpntMask === 'valorDecimal2') {
          if ([ '', null, undefined ].indexOf(this.value) !== -1) {
            this.value = '0,00'
          }

          this.onMaskValorDecimal2(this.value, true)
        }

        if (this.cpntOnBlur !== null) {
          this.cpntOnBlur(this.cpntId)
        }
      },
      onFocus: function () {
        if (this.cpntOnFocus !== null) {
          this.cpntOnFocus(this.cpntId)
        }
      }
    },
    watch: {
      'value': function () {
        if (this.value.length > this.maxLength) {
          this.value = this.value.slice(0, this.maxLength)
        }

        if (this.cpntValue !== this.value) {
          if (this.cpntValue !== this.value) {
            if (this.cpntMask === 'valor') {
              this.onMaskValor(this.value)
            } else {
            //   this.onMaskValorDecimal2(this.value)
            // } else {
              this.onChange(this.value)
            }
          }

          // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
          this.checarClassCampo()
        }
      },
      'cpntValue': function () {
        if (this.cpntValue !== this.value) {
          // SETA O VALOR DO INPU
          this.value = this.cpntValue

          if (this.cpntMask === 'valor') {
            this.onMaskValor(this.cpntValue)
          } else if (this.cpntMask === 'valorDecimal') {
            this.onMaskValorDecimal(this.cpntValue)
          // } else if (this.cpntMask === 'valorDecimal2') {
          //   this.onMaskValorDecimal2(this.cpntValue)
          }

          // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
          this.checarClassCampo()
        }
      },
      'cpntMask': function () {
        this.montarMascara() // INICIA A MONTAGEM DA MASCARA NO INPUT
      },
      cpntType: function () {
        this.type = this.cpntType
      }
    }
  }
</script>
